import { observer } from 'mobx-react';
import moment from 'moment';
import React from 'react';

import { DbKey } from '../../../adl-gen/common/db';
import { Quiz, QuizType, UserQuiz } from '../../../adl-gen/totalinteraction/futurefit/db';
import { AssessmentStatus, UserQuizData, UserQuizSummary } from '../../../adl-gen/totalinteraction/futurefit/frontend';
import { withI18n, WithI18nProps } from '../../../internationalization/i18n-hoc';
import { Loader, MaybeLoading } from '../../../loader/loader';
import { Route } from '../../../routing/app-routes';
import { LoggedIn } from '../../../stores/identity-store';
import { PageLayoutFn } from '../../common/page-layout/page-layout';
import { QuizTile, TileAccordions } from '../../components/tile-accordions/tile-accordions';

interface MyAssessmentsScreenProps extends WithI18nProps {
  pageLayout: PageLayoutFn;

  userHomeData: MaybeLoading<UserQuizData>;

  identity: LoggedIn;

  navigateTo(route: Route): void;

  onClickQuiz(quizId: DbKey<Quiz>, userQuizId: DbKey<UserQuiz>, status: AssessmentStatus, quizType: QuizType): void;

  walkThroughFn?(page: string): void;
}

@observer
class MyAssessmentsScreen0 extends React.Component<MyAssessmentsScreenProps> {
  renderUserQuizzes(userQuizzes: UserQuizSummary[]) {
    const { allowSelfAssessment } = this.props.identity.appClient;
    return (
      <TileAccordions
        kind={'progress-participant'}
        assessmentType={allowSelfAssessment ? 'self-assessment' : 'quiz-assessment'} // or undefined
        quizTiles={userQuizzes
          .filter(uQ => (allowSelfAssessment ? uQ.quizType === QuizType.selfAssessment : uQ.quizType === QuizType.quiz))
          .map((uQ, index) => this.userQuizToQuizTile(uQ, this.props.onClickQuiz, index))}
      />
    );
  }

  userQuizToQuizTile(
    userQuiz: UserQuizSummary,
    onClickQuiz: MyAssessmentsScreenProps['onClickQuiz'],
    index: number
  ): QuizTile {
    const subtitle =
      userQuiz.status.completedAt === null
        ? undefined
        : moment(userQuiz.status.completedAt).format('DD/MM/YYYY h:mm a');
    return {
      title: this.props.t(userQuiz.title),
      subtitle,
      imageUrl: userQuiz.imageUrl,
      progress: userQuiz.status.progress,
      total: userQuiz.status.total,
      id: userQuiz.userQuizId,
      onClick: () => onClickQuiz(userQuiz.quizId, userQuiz.userQuizId, userQuiz.status, userQuiz.quizType),
      enabled: userQuiz.status.completedAt === null || !userQuiz.lockResults,
      index
    };
  }

  renderLoaded = observer((userHomeData: UserQuizData) => {
    if (this.props.walkThroughFn) {
      this.props.walkThroughFn('');
    }
    return this.renderUserQuizzes(userHomeData.userQuizzes);
  });

  render() {
    return (
      <this.props.pageLayout>
        <Loader state={this.props.userHomeData} LoadedComponent={this.renderLoaded} />
      </this.props.pageLayout>
    );
  }
}

export const MyAssessmentsScreen = withI18n(MyAssessmentsScreen0);



// WEBPACK FOOTER //
// ./src/ui/screens/my-assessments-screen/my-assessments-screen.tsx